import { connect } from 'react-redux'
import { getPersisted, persist, clear } from 'utils/persistor'

export const usePersistence = (key) => ({
  get: (defaultValue) => getPersisted(key, defaultValue),
  getPersisted: (k, defaultValue) => getPersisted(k, defaultValue),
  setPersisted: (k, value) => persist(k, value),
  set: (value) => persist(key, value),
  getPartial: (name) => (getPersisted(key) || {})[name],
  setPartial: (name, value) => persist(key, { ...(getPersisted(key) || {}), ...{ [name]: value } }),
  clear: () => clear(key),
  key: () => key
})

export const withPersistence = (key, component) =>
  connect(
    () => ({
      persistor: usePersistence(key)
    })
  )(component)
